import { useContext } from 'react';

import {
  conditionalPremiumRoutes,
  staticPremiumRoutes,
} from '../constants/routes';
import CreditContext from '../context/credits/context';

export function useGetPremiumRoutes() {
  const { context: creditContext } = useContext(CreditContext);
  const { userCredit } = creditContext;
  const canGeneratePremium = userCredit.paidCredits > 0;

  if (canGeneratePremium) {
    return [...staticPremiumRoutes, ...conditionalPremiumRoutes];
  }

  return staticPremiumRoutes;
}
